module.exports = __webpack_public_path__ + "img/c9afb25.svg";